export const hasSlot = function (slotName = 'default') {
  return !!this.$slots[slotName]
}

export const component = {
  hasSlot
}
export default component
